import { Close, QueryStats } from "@mui/icons-material"
import { Button, IconButton, Popover, Stack, Tooltip, Typography } from "@mui/material"
import React from "react"

import { AgentsTableRow } from "./AgentsTableRow"
import { Agent } from "../../api/old-agents-api"
import { InMemoryTable } from "../../components/InMemoryTable"
import { AgentSvg } from "@/components/AgentSvg"
import ENV from "@/env"

const data: Agent[] = [
  {
    logo: "https://arweave.net/fTKfocxQs94bj444uVDiVKSZQ8bKu4rqkx5hHhjIYrw",
    developer: "Botega Team",
    developerLink: "https://botega.arweave.net",
    name: "DCA by Botega",
    version: "1.0.0",
    factory: ENV.VITE_AGENT_FACTORY_PROCESS,
    spawnMethod: "Create-DCA-Order",
    agentType: "dca-order",
    link: "https://botega.arweave.net/#/swap?type=dca",
  },
  {
    logo: "https://arweave.net/fTKfocxQs94bj444uVDiVKSZQ8bKu4rqkx5hHhjIYrw",
    developer: "Botega Team",
    developerLink: "https://botega.arweave.net",
    name: "Limit Order by Botega",
    version: "1.0.0",
    factory: ENV.VITE_AGENT_FACTORY_PROCESS,
    spawnMethod: "Create-Limit-Order",
    agentType: "limit-order",
    link: "https://botega.arweave.net/#/swap?type=limit",
  },
  {
    logo: "https://arweave.net/fTKfocxQs94bj444uVDiVKSZQ8bKu4rqkx5hHhjIYrw",
    developer: "Botega Team",
    developerLink: "https://botega.arweave.net",
    name: "Stop Loss Order by Botega",
    version: "1.0.0",
    factory: ENV.VITE_AGENT_FACTORY_PROCESS,
    spawnMethod: "Create-Stop-Order",
    agentType: "stop-order",
    link: "https://botega.arweave.net/#/swap?type=stop-loss",
  },
  {
    developer: "Dexi Team",
    developerLink: "https://dexi.arweave.net",
    name: "Portfolio Agents",
  },
]

export function AgentStats() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "agent-stats-popover" : undefined

  return (
    <>
      <Tooltip title="Agent Statistics">
        <Button
          onClick={handleClick}
          variant="outlined"
          color="secondary"
          size="small"
          sx={{
            minWidth: "unset",
            padding: 1,
            margin: 1,
          }}
        >
          <QueryStats />
        </Button>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        BackdropProps={{
          style: {
            opacity: 0,
          },
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root": {
            background: "var(--mui-palette-paperAlt)",
            border: "1px solid var(--mui-palette-divider)",
            padding: 2,
          },
        }}
      >
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          paddingX={1.5}
          justifyContent={"space-between"}
        >
          <Stack direction="row" gap={1} alignItems="center">
            <AgentSvg height={20} width={24} />
            <Typography variant="h6" fontWeight={600}>
              Agent Statistics
            </Typography>
          </Stack>
          <IconButton onClick={handleClose} edge="end" size="small">
            <Close />
          </IconButton>
        </Stack>
        <InMemoryTable
          initialSortField="balance"
          initialSortDir="desc"
          data={data}
          headerCells={[
            { sx: { width: "100%" }, label: "Name" },
            { sx: { minWidth: 140 }, label: "Volume" },
            { sx: { minWidth: 140 }, label: "Spawns" },
            { sx: { minWidth: 140 }, label: "Developer" },
          ]}
          renderRow={(row: Agent) => <AgentsTableRow key={row.name} row={row} />}
        />
      </Popover>
    </>
  )
}
